import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth";
import avatarReducer from "./avatar";
import livekitReducer from "./livekit";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { blacklist } from "validator";
const secretKey = import.meta.env.VITE_APP_SECRET_KEY;
console.log('secretKey', import.meta.env);

const encryptor = encryptTransform({
  secretKey: secretKey,
  onError: function (error) {
    // Handle the error.
    console.error("encryptTransform", error);
  },
});
const persistConfig = {
  key: "root:quiklearn:1.0.0",
  storage,
  // whitelist: ["auth", "auther"],
  blacklist: ["livekit"],
  transforms: [encryptor],
};

const rootReducer = combineReducers({
  auth: authReducer,
  avatar: avatarReducer,
  livekit: livekitReducer,

});
export default persistReducer(persistConfig, rootReducer);
